import ArticleDetailPage from "./components/ArticleDetailPage";
import CompanyInfoPage from "./components/CompanyInfoPage";
import ContactPage from "./components/ContactPage";
import InformationAllPage from "./components/InformationAllPage";
import PhilosophyPage from "./components/PhilosophyPage";
import PolicyPage from "./components/PolicyPage";
import ServiceCreativePage from "./components/service/ServiceCreativePage";
import ServiceDevelopmentPage from "./components/service/ServiceDevelopmentPage";
import ServiceProductPage from "./components/service/ServiceProductPage";
import ServicePage from "./components/ServiceSection";
import TopPage from "./components/TopPage";
import NotFoundPage from "./components/NotFoundPage";


const BASE_URL = process.env.REACT_APP_WORDPRESS_URL;


export const routes = [
  {
    path: "/",
    element: <TopPage />,
    meta: {
      title: "株式会社リブゲート｜システム開発・AI・ウェブ制作・ブランディング",
      description: "株式会社リブゲートは、ソフトウェア開発、AI・機械学習の導入、データサイエンス、ブランディング支援まで、課題特定から解決まで包括的なソリューションを提供します。ITにふれるすべての人々に「うれしい」を届けるコンシェルジュ指向の企業です。",
      image: `${BASE_URL}/images/og.png`,
    },
  },
  {
    path: "/philosophy/",
    element: <PhilosophyPage />,
    meta: {
      title: "企業理念｜株式会社リブゲート",
      description: "リブゲートのミッション「先端テクノロジーで、人々の課題を解決し、喜びと可能性を広げる」や、ビジョン、バリューを掲載しています。ITを喜びをもたらす力と捉え、誠実に向き合い価値を自分事化する、私たちの想いをお伝えします。",
      image: `${BASE_URL}/images/og.png`,
    },
  },
  {
    path: "/company/",
    element: <CompanyInfoPage />,
    meta: {
      title: "企業情報｜株式会社リブゲート",
      description: "株式会社リブゲートの企業情報です。システム開発、AI支援、データ解析、デジタルマーケティング、ブランディング等、多角的な事業内容を紹介。東京都中央区八丁堀の本社所在地や代表者情報、主要取引先、アクセス方法をご案内します。",
      image: `${BASE_URL}/images/og.png`,
    },
  },
  {
    path: "/service/",
    element: <ServicePage />,
    meta: {
      title: "事業紹介｜株式会社リブゲート",
      description: "リブゲートの3つの主要事業「開発」「クリエイティブ」「プロダクト」の概要です。基幹システム構築からWebサイト制作、自社バッグブランド「FADEN®」の展開まで、多角的な視点からお客様のビジネス成長を支援するソリューション一覧です。",
      image: `${BASE_URL}/images/og.png`,
    },
  },
  {
    path: "/service/development/",
    element: <ServiceDevelopmentPage />,
    meta: {
      title: "開発｜株式会社リブゲート",
      description: "リブゲートの開発サービスです。ソフトウェア、システムインフラの設計・開発から、AI・機械学習の導入、データサイエンス・BI活用まで対応。コンサルティング力を有するエンジニア集団が、お客様のビジネスに最適なシステムを提供します。",
      image: `${BASE_URL}/images/og.png`,
    },
  },
  {
    path: "/service/creative/",
    element: <ServiceCreativePage />,
    meta: {
      title: "クリエイティブ｜株式会社リブゲート",
      description: "リブゲートのクリエイティブサービスです。Webプロモーション、ブランディング戦略立案、Webサイト制作、SNS運用、UX/UIデザインまで幅広く対応。データに基づいた分析と心に届くコピーライティングで、ビジネスの成長を支援します。",
      image: `${BASE_URL}/images/og.png`,
    },
  },
  {
    path: "/service/product/",
    element: <ServiceProductPage />,
    meta: {
      title: "プロダクト｜株式会社リブゲート",
      description: "リブゲートが展開するバッグブランド「FADEN®（ファーデン）」の紹介です。クリエイティブディレクターが全工程を担当し、機能性とデザインを両立。「機能的だけど、ファッショナブル」をコンセプトに全国で流通するプロダクトのこだわりを掲載。",
      image: `${BASE_URL}/images/og.png`,
    },
  },
  {
    path: "/information/",
    element: <InformationAllPage />,
    meta: {
      title: "お知らせ｜株式会社リブゲート",
      description: "株式会社リブゲートの最新情報をお届けします。プレスリリース、サービス更新情報、技術やビジネスに関するナレッジ、社内の取り組みなど、当社の活動に関するニュースをご覧いただけます。",
      image: `${BASE_URL}/images/og.png`,
    },
  },
  {
    path: "/information/:id",
    element: <ArticleDetailPage />,
    meta: {
      title: "記事詳細｜株式会社リブゲートコーポレートサイト",
      description: "ニュース詳細です。株式会社リブゲートの最新の取り組みや、提供サービスに関する最新情報、専門的なナレッジ記事を掲載しています。",
      image: `${BASE_URL}/images/og.png`,
    },
  },
  {
    path: "/privacy-policy/",
    element: <PolicyPage />,
    meta: {
      title: "プライバシーポリシー｜株式会社リブゲート",
      description: "株式会社リブゲートのプライバシーポリシー。当社が取得する個人情報の利用目的、管理体制、第三者への提供、および開示手続きなど、個人情報の取り扱いに関する基本方針について詳しく掲載しています。",
      image: `${BASE_URL}/images/og.png`,
    },
  },
  {
    path: "/contact-us/",
    element: <ContactPage />,
    meta: {
      title: "問い合わせ｜株式会社リブゲートコーポレートサイト",
      description: "株式会社リブゲートへのご質問やご相談はこちらのフォームから承っております。サービスに関するお問い合わせや採用に関するご質問など、お気軽にご連絡ください。",
      image: `${BASE_URL}/images/og.png`,
    },
  },
  {
    path: "*",
    element: <NotFoundPage />,
    meta: {
      title: "ページが見つかりません｜株式会社リブゲートコーポレートサイト",
      description: "お探しのページは見つかりませんでした。",
      image: `${BASE_URL}/images/og.png`,
    },
  },
];
